import { render, staticRenderFns } from "./OlabUserProfile.vue?vue&type=template&id=1ec79a84&"
import script from "./OlabUserProfile.vue?vue&type=script&lang=js&"
export * from "./OlabUserProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports